import React, { Component } from 'react';
import NavbarDropdownItem from './NavbarDropdownItem';
import './styles.css';

export default class NavbarDropdown extends Component {

  render() {
    return (
      <div className={`navbar-dropdown ${this.props.className || ''}`}>
        <div className="navbar-dropdown-dismissal-backdrop" onClick={this.props.onDismissed}/>
        {this.props.items.map(item => <NavbarDropdownItem key={item.title} item={item} onClick={item.onClick || this.props.onDismissed}/>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDropdown/index.js